import { Skeleton } from "@/components/ui/skeleton";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { Zap, MapPin } from "lucide-react";

// Enhanced loading states for better UX
export const StationCardSkeleton = () => {
  return (
    <Card className="overflow-hidden animate-pulse">
      <div className="relative h-48 bg-muted">
        <div className="absolute inset-0 bg-gradient-to-r from-muted via-muted/50 to-muted animate-[shimmer_1.5s_ease-in-out_infinite]" />
      </div>
      <CardContent className="pt-4">
        <div className="space-y-3">
          <div className="flex justify-between items-start">
            <div className="space-y-2">
              <Skeleton className="h-5 w-36 bg-gradient-to-r from-muted via-muted/50 to-muted" />
              <div className="flex items-center gap-1">
                <MapPin className="h-3 w-3 text-muted-foreground" />
                <Skeleton className="h-4 w-24 bg-gradient-to-r from-muted via-muted/50 to-muted" />
              </div>
            </div>
            <Skeleton className="h-4 w-16 bg-gradient-to-r from-muted via-muted/50 to-muted" />
          </div>
          
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <Zap className="h-4 w-4 text-muted-foreground" />
              <Skeleton className="h-4 w-32 bg-gradient-to-r from-muted via-muted/50 to-muted" />
            </div>
            <Skeleton className="h-4 w-40 bg-gradient-to-r from-muted via-muted/50 to-muted" />
          </div>
          
          <div className="mt-2">
            <Skeleton className="h-6 w-24 bg-gradient-to-r from-muted via-muted/50 to-muted" />
          </div>
        </div>
      </CardContent>
      
      <CardFooter className="pt-0">
        <Skeleton className="h-10 w-full bg-gradient-to-r from-muted via-muted/50 to-muted" />
      </CardFooter>
    </Card>
  );
};

export const LoadingSpinner = ({ size = "default" }: { size?: "sm" | "default" | "lg" }) => {
  const sizeClasses = {
    sm: "h-4 w-4",
    default: "h-6 w-6", 
    lg: "h-8 w-8"
  };

  return (
    <div className="flex items-center justify-center">
      <Zap className={`${sizeClasses[size]} animate-spin text-primary`} />
    </div>
  );
};

export const LoadingOverlay = ({ message = "Loading..." }: { message?: string }) => {
  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center">
      <div className="bg-card p-6 rounded-lg shadow-lg border">
        <div className="flex items-center gap-3">
          <LoadingSpinner size="lg" />
          <p className="text-lg font-medium">{message}</p>
        </div>
      </div>
    </div>
  );
};

export const PageLoadingState = () => {
  return (
    <div className="container max-w-7xl py-6 px-4 md:px-6">
      <div className="mb-8">
        <Skeleton className="h-10 w-96 mb-4" />
        <Skeleton className="h-4 w-64" />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {Array.from({ length: 6 }).map((_, index) => (
          <StationCardSkeleton key={index} />
        ))}
      </div>
    </div>
  );
};